<template>
	<div class="jsonInterfaceContainer" ref="editorContainer">
		<fullscreen ref="fullscreen" @change="fullscreenChange">
			<i @click="gofullScreen()" class="el-icon-rank fullScreen"></i>
			<editor
				v-model="localJson"
				@init="editorInit"
				lang="json"
				theme="chrome"
				:height="fullscreen ? '100%' : height ? height : 250"
				:width="fullscreen ? '100%' : '99%'"
				class="jsonEditor"
				ref="jsonEditor"
			></editor>
		</fullscreen>
	</div>
</template>

<script>
import editor from "vue2-ace-editor";
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
export default {
	props: {
		json: String,
		height: String,
	},
	components: {
		editor,
	},
	computed: {
		...mapGetters(["returnReferencePath", "returnLastFocusedVariableInsertionInput"]),
	},
	data() {
		return {
			editor: null,
			componentId: uuidv4(),
			localJson: "",
			fullscreen: false,
			richMediaTemplates: [],
			automcompleteIs: null,
		};
	},
	watch: {
		localJson(state) {
			try {
				JSON.parse(state);
				this.$emit("jsonModified", state);
			} catch {
				//Allow for non legal JSON for input data reference interpolation reasons
				this.$emit("jsonModified", state);
			}
		},
		returnReferencePath: function () {
			if (this.returnLastFocusedVariableInsertionInput === this.componentId) {
				this.editor.session.insert(this.editor.getCursorPosition(), `{{${this.returnReferencePath.path}}}`);
				this.editor.focus();
			}
		},
	},
	beforeMount() {
		this.localJson = this.json ? _.cloneDeep(this.json) : "{}";
	},
	methods: {
		...mapActions(["updateLastFocusedVariableInsertionInputMETHOD"]),
		editorInit(editor) {
			const $this = this;
			this.editor = editor;
			require("brace/ext/language_tools");
			require("brace/theme/twilight");
			require("brace/theme/tomorrow_night_blue");
			require("brace/mode/json");
			require("brace/theme/chrome");
			const editorTextAreas = document.querySelectorAll(".jsonEditor .ace_text-input");
			editorTextAreas.forEach((editor, i) => {
				editor.addEventListener("focus", () => {
					$this.updateLastFocusedVariableInsertionInputMETHOD($this.componentId);
					document.getElementsByClassName("jsonEditor")[i].classList.add("focusInput");
				});
				editor.addEventListener("blur", () => {
					document.getElementsByClassName("jsonEditor")[i].classList.remove("focusInput");
				});
			});
			editor.setOptions({
				showPrintMargin: false,
				cursorStyle: "slim",
				enableBasicAutocompletion: true,
				enableSnippets: false,
				enableLiveAutocompletion: true,
			});
		},
		gofullScreen() {
			this.$refs["fullscreen"].toggle();
		},
		fullscreenChange(fullscreen) {
			this.fullscreen = fullscreen;
		},
	},
};
</script>

<style scoped>
.jsonInterfaceContainer {
	position: relative;
}

.jsonInterfaceContainer /deep/ .ace-chrome {
	border: 1px solid #dcdfe6;
	border-radius: 4px;
}
.jsonInterfaceContainer /deep/ .focusInput {
	border: 1px solid #210f3c !important;
	border-radius: 4px;
}

.fullScreen {
	transform: rotate(47deg);
	right: 10px;
	color: white;
	bottom: 10px;
	cursor: pointer;
	position: absolute;
	z-index: 100;
	font-size: 15px;
	background-color: #210f3c;
	border-radius: 50%;
	padding: 5px;
}
</style>
